/**
 * Dinheiro é sempre inteiro em centavos. Nenhum cálculo passa por float:
 * 0.1 + 0.2 em centavo de lanche vira reclamação no caixa.
 */
const FORMATADOR = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
});
/** 3070 → "R$ 30,70" */
export function formatarReais(cents) {
    if (!Number.isInteger(cents))
        throw new Error(`Centavos devem ser inteiros: ${cents}`);
    // O Intl usa espaço estreito (U+00A0) entre "R$" e o número; normaliza para espaço comum.
    return FORMATADOR.format(cents / 100).replace(/ /g, ' ');
}
/** "R$ 30,70" | "30,70" | "30.70" → 3070 */
export function parseReais(texto) {
    const limpo = texto.replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    const valor = Number(limpo);
    // Texto sem dígito nenhum limparia para '', e Number('') é 0 — um pedido grátis
    // passando calado. Exige pelo menos um dígito.
    if (!/\d/.test(limpo) || !Number.isFinite(valor)) {
        throw new Error(`Valor monetário inválido: ${texto}`);
    }
    return Math.round(valor * 100);
}
export function somarCents(valores) {
    return valores.reduce((acc, v) => acc + v, 0);
}
//# sourceMappingURL=dinheiro.js.map